import {ReactElement} from "react";

import {ErrorMessage} from "@/components/ErrorMessage/ErrorMessage";
import Loader from "@/components/Loader/Loader";
import {LoadingState} from "@/hooks/useLoadingState/useLoadingState";

interface LoadingOrErrorProps {
  loadingState: LoadingState;
  errorImage?: string;
  buttonToRefresh?: boolean;
  onRetry?: () => Promise<void>;
  children?: ReactElement;
  data?: any; // Données à vérifier
  dataValidator?: (data: any) => boolean; // Fonction de validation personnalisée
  haveReturnDate?: boolean;
  loaderIsSmall?: boolean;
}

export function LoadingOrError({
  loadingState,
  buttonToRefresh = false,
  loaderIsSmall = false,
  onRetry,
  children,
  data,
  dataValidator,
  haveReturnDate = true,
}: LoadingOrErrorProps): ReactElement | null {
  const {isLoading, hasError, error} = loadingState;

  // Validation des données
  const isDataValid = dataValidator
    ? dataValidator(data)
    : haveReturnDate
      ? !(data === undefined || data === null)
      : true;

  if (isLoading) {
    return <Loader isSmall={loaderIsSmall} />;
  }

  if (hasError && error) {
    return (
      <>
        <ErrorMessage
          text={error}
          buttonToRefresh={buttonToRefresh}
          onRetry={async () => await onRetry?.()}
        />
      </>
    );
  }

  // Vérifier que les données sont bien présentes et valides
  if (!isDataValid) {
    return (
      <>
        <ErrorMessage
          text="Données reçues invalides"
          buttonToRefresh={buttonToRefresh}
          onRetry={onRetry}
        />
      </>
    );
  }

  // Si pas de chargement, pas d'erreur et données valides, afficher le contenu
  return children || null;
}
